var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout mod-simple"},[(_vm.isLoggedIn)?_c('toolbar',{on:{"logout":_vm.$parent.logout}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row main-row"},[_c('div',{staticClass:"col-md-12 page-content"},[_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }